(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  const sectionEl = document.querySelector('.google-reviews-section');

  const starSvg = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';

  const renderStars = (rating) => {
    const full = Math.round(rating || 0);
    return Array.from({ length: 5 }, (_, i) =>
      `<span class="${i < full ? 'text-primary' : 'text-gray-300'}">${starSvg}</span>`
    ).join('');
  };

  const escapeHtml = (str) => (str || '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));

  const renderCard = (r) => `
    <li class="bg-white rounded-lg shadow-sm p-5 flex flex-col gap-3">
      <div class="flex items-center gap-3">
        ${r.avatar
          ? `<img src="${r.avatar}" alt="" width="40" height="40" loading="lazy" class="w-10 h-10 rounded-full object-cover">`
          : `<div class="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">${escapeHtml(r.author).charAt(0)}</div>`
        }
        <div>
          <p class="font-semibold text-sm">${escapeHtml(r.author)}</p>
          <p class="text-xs text-gray-500">${escapeHtml(r.relativeTime)}</p>
        </div>
      </div>
      <div class="flex gap-0.5">${renderStars(r.rating)}</div>
      <p class="text-sm text-black leading-6 line-clamp-3">${escapeHtml(r.text)}</p>
    </li>`;

  const loadReviews = async () => {
    try {
      const { endpoint, limit } = sectionEl.dataset;
      const res = await fetch(endpoint);
      if (!res.ok) return;
      const data = await res.json();
      if (!data.reviews || !data.reviews.length) return;

      const reviews = data.reviews.slice(0, Number(limit) || 5);

      sectionEl.querySelector('.google-reviews-summary').innerHTML = `
        <span class="text-3xl font-bold text-primary">${(data.rating || 0).toFixed(1)}</span>
        <span class="flex gap-0.5">${renderStars(data.rating)}</span>
        <span class="text-sm text-gray-600">${data.totalReviews} opiniones en Google</span>`;

      sectionEl.querySelector('.google-reviews-grid').innerHTML = reviews.map(renderCard).join('');

      if (data.mapsUrl) {
        const linkEl = sectionEl.querySelector('.google-reviews-link');
        linkEl.innerHTML = `<a href="${data.mapsUrl}" target="_blank" rel="noopener" class="text-primary font-semibold no-underline hover:underline">Ver todas las opiniones en Google</a>`;
        linkEl.classList.remove('hidden');
      }

      sectionEl.classList.remove('hidden');
    } catch (e) {
      /* silencioso: la sección simplemente no se muestra */
    }
  };

  const anchorEl = document.querySelector('.google-reviews-observer-anchor');

  if (sectionEl && anchorEl) {
    const observer = new IntersectionObserver((entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(anchorEl);
      loadReviews();
    }, { rootMargin: '0px 0px 400px 0px' });
    observer.observe(anchorEl);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url).then(response => response.text()).then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    }).catch(e => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["semantic-recommendations"] && !Shopify.designMode) return;
  try {
    
    const sectionEl = document.querySelector('.semantic-recommendations-section');

    const formatCOP = (cents) =>
      new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 })
        .format(cents / 100);

    // El CDN de Shopify redimensiona agregando ?width=N (o &width=N si la
    // URL ya trae query string, ej. el ?v= de versión) — sin esto se pedía
    // siempre la imagen original a tamaño completo en una tarjeta de 300px.
    const resizedUrl = (url, width) =>
      url ? `${url}${url.includes('?') ? '&' : '?'}width=${width}` : '';

    const escapeHtml = (str) => (str || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));

    const renderCard = (p) => `
      <li class="product">
        <a href="${p.url}" class="block bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
          <div class="aspect-square overflow-hidden">
            <img
              src="${resizedUrl(p.featured_image, 300)}"
              srcset="${p.featured_image ? `${resizedUrl(p.featured_image, 150)} 150w, ${resizedUrl(p.featured_image, 300)} 300w, ${resizedUrl(p.featured_image, 600)} 600w` : ''}"
              sizes="(min-width: 768px) 25vw, 50vw"
              alt="${escapeHtml(p.title)}"
              loading="lazy"
              width="300" height="300"
              class="w-full h-full object-contain"
            >
          </div>
          <div class="p-3 md:p-4">
            <h3 class="text-sm font-medium line-clamp-2">${escapeHtml(p.title)}</h3>
            <p class="mt-2 font-semibold">${formatCOP(p.price)}</p>
          </div>
        </a>
      </li>`;

    const loadRecommendations = async () => {
      try {
        const { sku, limit, endpoint } = sectionEl.dataset;
        const res = await fetch(`${endpoint}?sku=${encodeURIComponent(sku)}&limit=${limit}`);
        if (!res.ok) return;
        const { recommendations } = await res.json();
        if (!recommendations || !recommendations.length) return;

        // Datos de presentación vigentes desde Shopify (título, precio, stock)
        const products = await Promise.all(
          recommendations.map((r) =>
            fetch(`/products/${r.handle}.js`).then((x) => (x.ok ? x.json() : null)).catch(() => null)
          )
        );
        const available = products.filter((p) => p && p.available);
        if (!available.length) return;

        sectionEl.querySelector('.semantic-recommendations-grid').innerHTML =
          available.map(renderCard).join('');
        sectionEl.classList.remove('hidden');
      } catch (e) {
        /* silencioso: la sección simplemente no se muestra */
      }
    };

    if (sectionEl) {
      const observer = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.unobserve(sectionEl);
        loadRecommendations();
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(sectionEl);
    }

  } catch(e) { console.error(e); }
})();
})();
